import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Глобальные стили
import "./styles/base/variables.css";
import "./styles/base/base.css";

import './i18n/i18n'; 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
